import * as React from 'react';

function SvgFlash(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M9.784 22a.765.765 0 01-.754-.897v-.005l1.17-6.43H5.668a.667.667 0 01-.519-1.087L14.28 2.293a.769.769 0 011.366.571c0 .013-.003.025-.005.037l-1.175 6.433h4.533a.667.667 0 01.518 1.086l-9.132 11.288a.77.77 0 01-.601.292z" })));
}

export default SvgFlash;
